<template>
  <section
    id="header"
    class="navigation-wrap start-header"
    :class="[{ hidden: isHidden }]"
    :scroll="handleSCroll"
  >
    <nav class="navbar navbar-expand-md p-0 h-100">
      <div class="container-fluid h-100">
        <div class="d-flex align-center justify-start gap-3">
          <div
            class="sidebar-toggler"
            @click="toggleSideBar"
            :class="[{ 'd-none d-md-none d-lg-none': isHidden }]"
          ></div>
          <div
            class="separator d-block d-md-none d-lg-none"
            :class="[{ 'd-none d-md-none d-lg-none': isHidden }]"
          ></div>
          <router-link
            v-if="isHidden && !isMobile"
            class="navbar-brand"
            :to="{ name: 'home' }"
            ><img :src="require('@/assets/images/logo-white.png')" alt=""
          /></router-link>
          <router-link v-else class="navbar-brand" :to="{ name: 'home' }"
            ><img class="brand-on-light" :src="require('@/assets/images/logo.png')" alt=""
            /><img class="brand-on-dark" :src="require('@/assets/images/logo-white.png')" alt=""
          /></router-link>
        </div>
        <button
          v-if="data.isLogin"
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbar-profile"
          aria-controls="navbar-profile"
          aria-expanded="false"
          aria-label="Toggle navigation"
          :class="[{ 'd-none d-md-none d-lg-none': isHidden }]"
        >
          <div
            v-if="profile?.avatar == null"
            class="avatar-m d-flex align-items-center justify-center"
          >
            {{ initials(profile?.fullname) }}
          </div>
          <img v-else :src="profile?.avatar" class="avatar-m" />
        </button>
        <div
          v-else
          class="navbar-toggler"
          :class="[{ 'd-none d-md-none d-lg-none': isHidden }]"
        >
          <router-link :to="{ name: 'login' }" class="btn btn-primary w-100"
            >Masuk</router-link
          >
        </div>
        <div
          class="collapse navbar-collapse"
          id="navbar-profile"
          :class="[{ 'd-none d-md-none d-lg-none': isHidden }]"
        >
          <ul
            class="d-lg-flex d-md-flex d-none navbar-nav mx-auto justify-content-center"
            :class="[{ 'd-none d-md-none d-lg-none': isHidden }]"
          >
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Program Dilatih
              </a>
              <ul class="dropdown-menu">
                <li>
                  <router-link
                    :to="{ name: 'dilatih-insight' }"
                    class="dropdown-item"
                    href="#"
                    >Dilatih Insight</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{ name: 'dilatih-workshop' }"
                    class="dropdown-item"
                    href="#"
                    >Dilatih Workshop</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{ name: 'sertifikasi-bnsp' }"
                    class="dropdown-item"
                    href="#"
                    >Sertifikasi BNSP</router-link
                  >
                </li>
              </ul>
            </li>
            <!-- <li class="nav-item">
              <router-link :to="{ name: 'prodis' }" class="nav-link"
                >Promo & Diskon</router-link
              >
            </li> -->
            <li class="nav-item">
              <router-link :to="{ name: 'in-house-training' }" class="nav-link"
                >Untuk Perusahaan</router-link
              >
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'blog' }" class="nav-link"
                >Blog</router-link
              >
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'about-us' }" class="nav-link"
                >Tentang Kami</router-link
              >
            </li>
          </ul>
          <div
            class="d-block d-md-none d-lg-none"
            :class="[{ 'd-none d-md-none d-lg-none': isHidden }]"
          >
            <ul v-if="profile?.id_role == 1" class="navbar-nav">
              <li class="nav-item">
                <router-link
                  :to="{ name: 'admin-dashboard' }"
                  class="side-link"
                  @click="toggleDropdown"
                  ><span class="icon-dash"
                    ><img
                      :src="require('@/assets/images/cms/dashboard.svg')"
                      alt=""
                      srcset="" /></span
                  >Dashboard</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: 'admin-landing-page' }"
                  class="side-link"
                  @click="toggleDropdown"
                  ><span class="icon-dash"
                    ><img
                      :src="require('@/assets/images/cms/cms.svg')"
                      alt=""
                      srcset="" /></span
                  >CMS LandingPage</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: 'admin-partnership' }"
                  class="side-link"
                  @click="toggleDropdown"
                  ><span class="icon-dash"
                    ><img
                      :src="require('@/assets/images/cms/partner.svg')"
                      alt=""
                      srcset="" /></span
                  >Dilatih partnership</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: 'admin-insight' }"
                  class="side-link"
                  @click="toggleDropdown"
                  ><span class="icon-dash"
                    ><img
                      :src="require('@/assets/images/cms/insight.svg')"
                      alt=""
                      srcset="" /></span
                  >Dilatih Insight</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: 'admin-workshop' }"
                  class="side-link"
                  @click="toggleDropdown"
                  ><span class="icon-dash"
                    ><img
                      :src="require('@/assets/images/cms/workshop.svg')"
                      alt=""
                      srcset="" /></span
                  >Dilatih Workshop</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: 'admin-class' }"
                  class="side-link"
                  @click="toggleDropdown"
                  ><span class="icon-dash"
                    ><img
                      :src="require('@/assets/images/cms/class.svg')"
                      alt=""
                      srcset="" /></span
                  >Dilatih Class</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: 'admin-management' }"
                  class="side-link"
                  @click="toggleDropdown"
                  ><span class="icon-dash"
                    ><img
                      :src="require('@/assets/images/cms/user.svg')"
                      alt=""
                      srcset="" /></span
                  >User Management</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: 'admin-affiliate' }"
                  class="side-link"
                  @click="toggleDropdown"
                  ><span class="icon-dash"
                    ><img
                      :src="require('@/assets/images/cms/referral.svg')"
                      alt=""
                      srcset="" /></span
                  >Affiliate</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: 'admin-payment' }"
                  class="side-link"
                  @click="toggleDropdown"
                  ><span class="icon-dash"
                    ><img
                      :src="require('@/assets/images/cms/payment.svg')"
                      alt=""
                      srcset="" /></span
                  >Payment & Report</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: 'admin-settings' }"
                  class="side-link"
                  @click="toggleDropdown"
                  ><span class="icon-dash"
                    ><img
                      :src="require('@/assets/images/cms/settings.svg')"
                      alt=""
                      srcset="" /></span
                  >System Settings</router-link
                >
              </li>
              <li class="nav-item">
                <button class="side-link sign-out" @click="logout()">
                  <span class="icon-dash"
                    ><img
                      :src="require('@/assets/images/admin/sign-out.png')"
                      alt=""
                      srcset="" /></span
                  >Keluar
                </button>
              </li>
            </ul>
            <ul v-if="profile?.id_role == 2" class="navbar-nav">
              <li class="nav-item">
                <router-link
                  :to="{ name: 'dashboard' }"
                  class="side-link"
                  @click="toggleDropdown"
                  ><span class="icon-dash"
                    ><img
                      :src="require('@/assets/images/admin/dashboard.png')"
                      alt=""
                      srcset="" /></span
                  >Dashboard</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: 'user-dilatih-insight' }"
                  class="side-link"
                  @click="toggleDropdown"
                  ><span class="icon-dash"
                    ><img
                      :src="require('@/assets/images/admin/insight.png')"
                      alt=""
                      srcset="" /></span
                  >Dilatih Insight</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: 'user-dilatih-workshop' }"
                  class="side-link"
                  @click="toggleDropdown"
                  ><span class="icon-dash"
                    ><img
                      :src="require('@/assets/images/admin/workshop.png')"
                      alt=""
                      srcset="" /></span
                  >Dilatih Workshop</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: 'certificate' }"
                  class="side-link"
                  @click="toggleDropdown"
                  ><span class="icon-dash"
                    ><img
                      :src="require('@/assets/images/admin/certificate.png')"
                      alt=""
                      srcset="" /></span
                  >Sertifikat</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: 'transaction' }"
                  class="side-link"
                  @click="toggleDropdown"
                  ><span class="icon-dash"
                    ><img
                      :src="require('@/assets/images/admin/transaction.png')"
                      alt=""
                      srcset="" /></span
                  >Daftar Transaksi</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: 'profile-pengguna' }"
                  class="side-link"
                  @click="toggleDropdown"
                  ><span class="icon-dash"
                    ><img
                      :src="require('@/assets/images/admin/profile.png')"
                      alt=""
                      srcset="" /></span
                  >Profile</router-link
                >
              </li>
              <li class="nav-item">
                <button class="side-link sign-out" @click="logout()">
                  <span class="icon-dash"
                    ><img
                      :src="require('@/assets/images/admin/sign-out.png')"
                      alt=""
                      srcset="" /></span
                  >Keluar
                </button>
              </li>
            </ul>
          </div>
          <div
            class="d-md-flex d-lg-flex d-none"
            :class="[{ 'd-none d-md-none d-lg-none': isHidden }]"
          >
            <ul v-if="Logged" class="navbar-nav">
              <li class="nav-item dropdown">
                <a
                  class="nav-link"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <div
                    v-if="profile.avatar == null"
                    class="avatar-m d-flex align-items-center justify-center"
                  >
                    {{ initials(profile.fullname) }}
                  </div>
                  <img v-else :src="profile.avatar" class="avatar-m" />
                </a>
                <ul
                  v-if="profile.id_role == 1"
                  class="dropdown-menu dropdown-menu-end"
                >
                  <router-link
                    :to="{ name: 'admin-dashboard' }"
                    class="side-link"
                    @click="toggleSideBar"
                    ><span class="icon-dash"
                      ><img
                        :src="require('@/assets/images/cms/dashboard.svg')"
                        alt=""
                        srcset="" /></span
                    >Dashboard</router-link
                  >
                  <router-link
                    :to="{ name: 'admin-landing-page' }"
                    class="side-link"
                    @click="toggleSideBar"
                    ><span class="icon-dash"
                      ><img
                        :src="require('@/assets/images/cms/cms.svg')"
                        alt=""
                        srcset="" /></span
                    >CMS Landing Page</router-link
                  >
                  <router-link
                    :to="{ name: 'admin-partnership' }"
                    class="side-link"
                    @click="toggleSideBar"
                    ><span class="icon-dash"
                      ><img
                        :src="require('@/assets/images/cms/partner.svg')"
                        alt=""
                        srcset="" /></span
                    >Dilatih partnership</router-link
                  >
                  <router-link
                    :to="{ name: 'admin-insight' }"
                    class="side-link"
                    @click="toggleSideBar"
                    ><span class="icon-dash"
                      ><img
                        :src="require('@/assets/images/cms/insight.svg')"
                        alt=""
                        srcset="" /></span
                    >Dilatih Insight</router-link
                  >
                  <router-link
                    :to="{ name: 'admin-workshop' }"
                    class="side-link"
                    @click="toggleSideBar"
                    ><span class="icon-dash"
                      ><img
                        :src="require('@/assets/images/cms/workshop.svg')"
                        alt=""
                        srcset="" /></span
                    >Dilatih Workshop</router-link
                  >
                  <router-link
                    :to="{ name: 'admin-class' }"
                    class="side-link"
                    @click="toggleSideBar"
                    ><span class="icon-dash"
                      ><img
                        :src="require('@/assets/images/cms/class.svg')"
                        alt=""
                        srcset="" /></span
                    >Dilatih Class</router-link
                  >
                  <router-link
                    :to="{ name: 'admin-management' }"
                    class="side-link"
                    @click="toggleSideBar"
                    ><span class="icon-dash"
                      ><img
                        :src="require('@/assets/images/cms/user.svg')"
                        alt=""
                        srcset="" /></span
                    >User Management</router-link
                  >
                  <router-link
                    :to="{ name: 'admin-affiliate' }"
                    class="side-link"
                    @click="toggleSideBar"
                    ><span class="icon-dash"
                      ><img
                        :src="require('@/assets/images/cms/referral.svg')"
                        alt=""
                        srcset="" /></span
                    >Affiliate</router-link
                  >
                  <router-link
                    :to="{ name: 'admin-payment' }"
                    class="side-link"
                    @click="toggleSideBar"
                    ><span class="icon-dash"
                      ><img
                        :src="require('@/assets/images/cms/payment.svg')"
                        alt=""
                        srcset="" /></span
                    >Payment & Report</router-link
                  >
                  <router-link
                    :to="{ name: 'admin-settings' }"
                    class="side-link"
                    @click="toggleSideBar"
                    ><span class="icon-dash"
                      ><img
                        :src="require('@/assets/images/cms/settings.svg')"
                        alt=""
                        srcset="" /></span
                    >System Settings</router-link
                  >
                  <button class="side-link sign-out" @click="logout()">
                    <span class="icon-dash"
                      ><img
                        :src="require('@/assets/images/admin/sign-out.png')"
                        alt=""
                        srcset="" /></span
                    >Keluar
                  </button>
                </ul>
                <ul
                  v-if="profile.id_role == 2"
                  class="dropdown-menu dropdown-menu-end profile"
                >
                  <router-link
                    :to="{ name: 'dashboard' }"
                    class="side-link"
                    @click="toggleSideBar"
                    ><span class="icon-dash"
                      ><img
                        :src="require('@/assets/images/admin/dashboard.png')"
                        alt=""
                        srcset="" /></span
                    >Dashboard</router-link
                  >
                  <router-link
                    :to="{ name: 'user-dilatih-insight' }"
                    class="side-link"
                    @click="toggleSideBar"
                    ><span class="icon-dash"
                      ><img
                        :src="require('@/assets/images/admin/insight.png')"
                        alt=""
                        srcset="" /></span
                    >Dilatih Insight</router-link
                  >
                  <router-link
                    :to="{ name: 'user-dilatih-workshop' }"
                    class="side-link"
                    @click="toggleSideBar"
                    ><span class="icon-dash"
                      ><img
                        :src="require('@/assets/images/admin/workshop.png')"
                        alt=""
                        srcset="" /></span
                    >Dilatih Workshop</router-link
                  >
                  <router-link
                    :to="{ name: 'certificate' }"
                    class="side-link"
                    @click="toggleSideBar"
                    ><span class="icon-dash"
                      ><img
                        :src="require('@/assets/images/admin/certificate.png')"
                        alt=""
                        srcset="" /></span
                    >Sertifikat</router-link
                  >
                  <router-link
                    :to="{ name: 'transaction' }"
                    class="side-link"
                    @click="toggleSideBar"
                    ><span class="icon-dash"
                      ><img
                        :src="require('@/assets/images/admin/transaction.png')"
                        alt=""
                        srcset="" /></span
                    >Daftar Transaksi</router-link
                  >
                  <router-link
                    :to="{ name: 'profile-pengguna' }"
                    class="side-link"
                    @click="toggleSideBar"
                    ><span class="icon-dash"
                      ><img
                        :src="require('@/assets/images/admin/profile-user.png')"
                        alt=""
                        srcset="" /></span
                    >Profile</router-link
                  >
                  <button class="side-link sign-out" @click="logout()">
                    <span class="icon-dash"
                      ><img
                        :src="require('@/assets/images/admin/sign-out.png')"
                        alt=""
                        srcset="" /></span
                    >Keluar
                  </button>
                </ul>
                <ul
                  v-if="profile.id_role == 6"
                  class="dropdown-menu dropdown-menu-end profile"
                >
                  <router-link
                    :to="{ name: 'affiliate-dashboard' }"
                    class="side-link"
                    ><span class="icon-dash"
                      ><img
                        :src="require('@/assets/images/cms/dashboard.svg')"
                        alt=""
                        srcset="" /></span
                    >Dashboard</router-link
                  >
                  <button class="side-link sign-out" @click="logout()">
                    <span class="icon-dash"
                      ><img
                        :src="require('@/assets/images/admin/sign-out.png')"
                        alt=""
                        srcset="" /></span
                    >Keluar
                  </button>
                </ul>
                <ul
                  v-if="profile.id_role >= 3"
                  class="dropdown-menu dropdown-menu-end profile"
                >
                  <router-link
                    :to="{ name: 'trainer-dashboard' }"
                    class="side-link"
                    ><span class="icon-dash"
                      ><img
                        :src="require('@/assets/images/cms/dashboard.svg')"
                        alt=""
                        srcset="" /></span
                    >Dashboard</router-link
                  >
                  <button class="side-link sign-out" @click="logout()">
                    <span class="icon-dash"
                      ><img
                        :src="require('@/assets/images/admin/sign-out.png')"
                        alt=""
                        srcset="" /></span
                    >Keluar
                  </button>
                </ul>
              </li>
            </ul>
            <div v-else class="d-flex justify-content-center gap-2">
              <router-link :to="{ name: 'register' }" class="btn w-100"
                >Daftar</router-link
              >
              <router-link :to="{ name: 'login' }" class="btn btn-primary w-100"
                >Masuk</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </nav>
  </section>
</template>
<script>
import { useStore } from 'vuex'
import { reactive, onMounted, computed, onBeforeUnmount, ref } from 'vue'
import Swal from 'sweetalert2'
import { useLoading } from 'vue-loading-overlay'
import { useToast } from 'vue-toastification'
import { useRouter, useRoute } from 'vue-router'

export default {
  setup() {
    const store = useStore()
    const toast = useToast()
    const router = useRouter()
    const $loading = useLoading({})
    const data = reactive({
      isLogin: false,
    })
    const isMobile = ref(false)

    const profile = computed(() => {
      return JSON.parse(window.localStorage.getItem('user'))
    })

    const Logged = computed(() => {
      // return store.state.auth.token
      //   ? store.state.auth.token
      //   : localStorage.getItem('token')
      return store.getters['auth/isLoggedIn']
    })

    const ip = computed(() => {
      return window.localStorage.getItem('ip')
    })

    function logout() {
      toggleDropdown()
      Swal.fire({
        icon: 'info',
        title: 'apa anda yakin ingin keluar ?',
        showDenyButton: true,
        confirmButtonText: 'Ya, saya yakin',
        denyButtonText: `Batalkan`,
      }).then((result) => {
        if (result.isConfirmed) {
          const loader = $loading.show()
          let ip_address = ip.value
          store
            .dispatch('auth/logout', {
              ip_address,
            })
            .then(() => {
              toast.success('berhasil logout!')
              loader.hide()
              router.push({ name: 'login' })
              return
            })
            .catch(() => {
              toast.error('internal server error!')
              loader.hide()
              return
            })
        } else if (result.isDenied) {
          // Swal.fire('Changes are not saved', '', 'info')
        }
      })
    }

    function handleSCroll() {
      let header = document.querySelector('.start-header')
      if (window.scrollY > 80 && !header.className.includes('scroll-on')) {
        header.classList.add('scroll-on')
      } else if (window.scrollY < 80) {
        header.classList.remove('scroll-on')
      }
    }

    function cek_login() {
      if (store.getters['auth/isLoggedIn']) {
        data.isLogin = true
      }
    }

    onMounted(() => {
      // if (typeof profile.avatar === "undefined" && data.isLogin) {
      //   let ip_address = ip.value;
      //   store.dispatch("auth/logout", {
      //     ip_address,
      //   });
      //   data.isLogin = false;
      // }
      window.addEventListener('resize', handleResize)
      handleResize()
      cek_login()
    })

    onBeforeUnmount(() => {
      window.removeEventListener('resize', handleResize)
    })

    const handleResize = () => {
      isMobile.value = window.innerWidth <= 767.98
    }

    function toggleSideBar() {
      let toggler = document.querySelector('.sidebar-toggler')
      let nav = document.querySelector('.l-navbar')
      nav.classList.toggle('show')
      if (nav.className.includes('show')) {
        toggler.classList.add('sidebar-open')
      } else {
        toggler.classList.remove('sidebar-open')
      }
    }

    function toggleDropdown() {
      let toggler = document.getElementById('navbar-profile')
      if (toggler.classList.contains('show')) {
        toggler.classList.remove('show')
      }
    }

    const routeName = computed(() => {
      return useRoute().name
    })
    const isHidden = computed(() => {
      if (
        routeName.value == 'register' ||
        routeName.value == 'login' ||
        routeName.value == 'affiliate-login' ||
        routeName.value == 'webinar-register' ||
        routeName.value == 'workshop-register' ||
        routeName.value == 'forget-password' ||
        routeName.value == 'confirm-new-password'
      ) {
        return true
      } else {
        return false
      }
    })

    return {
      isMobile,
      isHidden,
      toggleDropdown,
      data,
      handleSCroll,
      profile,
      logout,
      Logged,
      toggleSideBar,
    }
  },
}
</script>
